import * as React from 'react';
export const trashSvg = React.forwardRef(function trashSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9 3V1.5A1.5 1.5 0 0 0 7.5 0h-3A1.5 1.5 0 0 0 3 1.5V3H.75a.75.75 0 0 0 0 1.5h.75V10a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V4.5h.75a.75.75 0 0 0 0-1.5H9ZM7.5 1.4h-3a.1.1 0 0 0-.1.1V3h3.2V1.5a.1.1 0 0 0-.1-.1Zm1.6 3.1V10a.6.6 0 0 1-.6.6h-5a.6.6 0 0 1-.6-.6V4.5h6.2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.625 5.5c.345 0 .625.28.625.625v2.75a.625.625 0 1 1-1.25 0v-2.75c0-.345.28-.625.625-.625Zm2.75 0c.345 0 .625.28.625.625v2.75a.625.625 0 1 1-1.25 0v-2.75c0-.345.28-.625.625-.625Z',
    }),
  );
});
trashSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var trash = {
  category: 'icon',
  colorable: true,
  name: 'trash',
  svg: trashSvg,
};
